module.exports = {
  decode: require('./decode'),
  verify: require('./verify'),
  sign: require('./sign'),
  JsonWebTokenError: require('./lib/JsonWebTokenError'),
  NotBeforeError: require('./lib/NotBeforeError'),
  TokenExpiredError: require('./lib/TokenExpiredError'),
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonwebtoken/index.js
 ** module id = 2951
 ** module chunks = 0
 **/